// @flow

import * as React from 'react';

import { Base } from '@gandi/ui';

type Props = {|
  title: string,
  message: string,
|};

function SearchError({ title, message }: Props): React.Element<typeof Base> {
  return (
    <Base flex flexCol backgroundColor="white" padding="small">
      <Base tagName="p" weight="semibold" margin="none" marginBottom="xsmall">
        {title}
      </Base>

      <Base tagName="p" weight="semibold" color="light" margin="none">
        {message}
      </Base>
    </Base>
  );
}

export default SearchError;
